export var FormTitles;
(function (FormTitles) {
    FormTitles["default"] = "\u0414\u0430\u043D\u043D\u044B\u0435 \u043E \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438";
    FormTitles["edit"] = "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0434\u0430\u043D\u043D\u044B\u0445 \u043E \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438";
})(FormTitles || (FormTitles = {}));
export var ButtonTitles;
(function (ButtonTitles) {
    ButtonTitles["default"] = "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C";
    ButtonTitles["edit"] = "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C";
})(ButtonTitles || (ButtonTitles = {}));
